import { compose, flatten, map, prop, uniq } from 'ramda'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { Absolute, Relative } from '../helpers/Position'
import { Col, Grid } from '../structure/Grid'
import { Tags } from '../presentation/Tag'
import Background from '../structure/Background'
import Button from '../actions/Button'
import Icon from '../shapes/Icon'
import Image from '../../../../components/presentation/Image'
import Line from '../helpers/Line'
import Panel from '../structure/Panel'
import Separator from '../helpers/Separator'
import Text, { Title } from '../presentation/Text'

const CardItem = ({ option, onChange }) => {
  const { t } = useTranslation('common')
  return (
    <Col width="33%">
      <Relative width="100%">
        <Absolute top={0.4} right={0.4}>
          <Tags values={option.categories || []} color="light2" size="small" />
        </Absolute>
        <Panel onClick={() => onChange(option, option.id)} minHeight={19} noPadding>
          <Background
            bgColor={option.color || 'cyan'}
            pattern="random"
            height={8}
            align="center"
            justify="center"
            noRadiusBottom
          >
            {option.icon && <Icon name={option.icon || 'RiDashboard3Line'} color="white" size={5} />}
            {option.image && <Image src={option.image} width={'8rem'} />}
          </Background>
          <Separator weight={4} flex={1}>
            <Title size="h5" noMargin>
              {option.name}
            </Title>
            <Text size="small">{option.description}</Text>
            <Separator weight={2} />
            {option.content}
            <Separator weight={4} />
            <Col flex={1} />
            <Button transparent color="dark4">
              {t('select')}
            </Button>
          </Separator>
        </Panel>
      </Relative>
    </Col>
  )
}

const CardPicker = ({ options, onChange }) => {
  const categories = compose(uniq, flatten, map(prop('categories')))(options)

  return (
    <Grid gap={0.4}>
      <Col flex={3}>
        {categories.map(category => (
          <div id={'category'} key={category}>
            <Title size="h6" color="dark3">
              {category}
            </Title>
            <Line />
            <Separator weight={6} />
            <Grid paddingGutter={0.4} wrap>
              {options
                .filter(item => item.categories.includes(category))
                .map(option => (
                  <CardItem key={option.id} option={option} onChange={onChange} />
                ))}
            </Grid>

            <Separator weight={8} />
          </div>
        ))}
      </Col>
    </Grid>
  )
}

export default CardPicker
